import { useEffect } from 'react';
import { eventTargetIsEditable, isHubQuickSearchGloballyBlocked } from '../utils/isEditableTarget';

export interface UseHubQuickSearchHotkeyOptions {
  enabled?: boolean;
  onOpen: () => void;
  /** When true, Space will not open search (page modals, etc.). */
  blocked?: boolean;
}

/** Opens hub quick search on Space (when not typing in a field). */
export function useHubQuickSearchHotkey({
  enabled = true,
  onOpen,
  blocked = false,
}: UseHubQuickSearchHotkeyOptions): void {
  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== ' ' || e.repeat) return;
      if (blocked || isHubQuickSearchGloballyBlocked()) return;
      if (eventTargetIsEditable(e)) return;
      e.preventDefault();
      onOpen();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enabled, onOpen, blocked]);
}
